<template>
  <div>
    <LayoutIntroductionHeaderComponent :page="page" />
    <pagesJournalsQueryComponent  />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object,
})

const page = baseStrapiGetAttributes(props.data)

</script>

<style module>
</style>
